module.exports = __webpack_public_path__ + "static/media/mobile.a892360b.svg";